export default __webpack_public_path__ + "static/media/leetcode.fd3c9a86.png";